import styled from "@emotion/styled";
import { fontRobotoCondensed } from "@product/scmp-sdk";

import { BaseImage } from "~/components/common/base-image";
import { EntityFollowButton } from "~/components/entity-follow-button";
import { SponsorTag } from "~/components/sponsor-tag";

import { TopicHeaderRelatedLinks } from "./topic-header-related-links";

export const Container = styled.div`
  border-block-end: 1px solid #0000001a;
`;

type WrapperProps = {
  $hasSponsor: boolean;
};
export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: ${props => (props.$hasSponsor ? "column" : "row")};
  gap: 20px;

  margin-block-end: 16px;
  ${props => props.theme.breakpoints.between("tablet", "homeDesktop")} {
    gap: 16px;
  }

  ${props => props.theme.breakpoints.up("homeDesktop")} {
    flex-direction: row;
    align-items: center;

    margin-block-end: 20px;
  }
`;

export const ImageIcon = styled(BaseImage)`
  inline-size: 64px;
  block-size: 64px;

  border: 1px solid #dadada;
  border-radius: 50%;

  object-fit: cover;
  object-position: 50%;

  ${props => props.theme.breakpoints.up("tablet")} {
    inline-size: 96px;
    block-size: 96px;
  }
  ${props => props.theme.breakpoints.up("homeDesktop")} {
    inline-size: 120px;
    block-size: 120px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
`;

type LabelContainerProps = {
  $isGeneralTopic: boolean;
};

export const LabelContainer = styled.div<LabelContainerProps>`
  display: flex;
  align-items: center;

  margin-block-end: 4px;
  ${props => props.theme.breakpoints.up("homeDesktop")} {
    margin-block-end: ${props => (props.$isGeneralTopic ? "8px" : "0")};
  }
`;

export const Label = styled.div`
  color: #a1a1a1;
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 18.75px;
`;

export const TypeLabel = styled.div`
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 18.75px;
  text-transform: uppercase;
  span {
    color: #a1a1a1;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`;

export const Title = styled.h1`
  flex: 1;

  font-weight: 700;
  font-size: 24px;
  font-family: ${fontRobotoCondensed};
  line-height: 28.13px;
  text-transform: uppercase;

  ${props => props.theme.breakpoints.up("tablet")} {
    flex: initial;

    font-size: 32px;
    line-height: 37.5px;
  }

  ${props => props.theme.breakpoints.up("homeDesktop")} {
    font-size: 48px;
    line-height: 56.25px;
  }
`;

export const StyledEntityFollowButton = styled(EntityFollowButton)`
  white-space: nowrap;
  button {
    inline-size: auto;
    padding-block: 4px;
    padding-inline: 8px;

    font-weight: 400;
    font-size: 14px;
    font-family: ${fontRobotoCondensed};
    line-height: 19.6px;
  }
`;

export const StyledRelatedLinks = styled(TopicHeaderRelatedLinks)``;

export const StyledSponsorTag = styled(SponsorTag)`
  flex-direction: row;
  gap: 4px;

  inline-size: fit-content;
  padding: 8px;

  font-size: 13px;
  line-height: 16.9px;

  border: 1px solid #d7d7d7;

  ${props => props.theme.breakpoints.up("tablet")} {
    font-size: 14px;
    line-height: 18.2px;
  }

  ${props => props.theme.breakpoints.up("homeDesktop")} {
    flex-direction: column;
    gap: 0;
    align-self: end;
  }
`;
